import React from 'react';
import { Select, Text } from '@gravity-ui/uikit';
import { transformArrIn, transformArrOut } from '../../../../core';
import { block } from '../../../utils';
import './MultiSelect.css';
const b = block('multi-select');
export const MultiSelect = ({ name, input, spec, inputProps }) => {
    var _a, _b, _c, _d;
    const { value, onBlur, onChange, onFocus } = input;
    const filterable = React.useMemo(() => { var _a; return (((_a = spec.enum) === null || _a === void 0 ? void 0 : _a.length) || 0) > 9; }, [(_a = spec.enum) === null || _a === void 0 ? void 0 : _a.length]);
    const { withCustomOptions, options: externalOptions } = inputProps || {};
    const options = React.useMemo(() => {
        var _a;
        return withCustomOptions
            ? externalOptions || []
            : (_a = spec.enum) === null || _a === void 0 ? void 0 : _a.map((id) => {
                var _a, _b, _c, _d, _e;
                return ({
                    id,
                    value: id,
                    text: ((_a = spec.description) === null || _a === void 0 ? void 0 : _a[id]) || id,
                    content: ((_c = (_b = spec.viewSpec.selectParams) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c[id]) ? (React.createElement("div", { key: id },
                        React.createElement(Text, null, ((_d = spec.description) === null || _d === void 0 ? void 0 : _d[id]) || id),
                        React.createElement(Text, { color: "secondary", className: b('meta-text') }, spec.viewSpec.selectParams.meta[id]))) : (((_e = spec.description) === null || _e === void 0 ? void 0 : _e[id]) || id),
                    key: id,
                });
            });
    }, [
        spec.enum,
        spec.description,
        (_b = spec.viewSpec.selectParams) === null || _b === void 0 ? void 0 : _b.meta,
        externalOptions,
        withCustomOptions,
    ]);
    const renderOption = React.useCallback((option) => {
        return React.createElement(React.Fragment, { key: option.value }, option.content || option.value);
    }, []);
    const getOptionHeight = React.useCallback(() => {
        var _a;
        if ((_a = spec.viewSpec.selectParams) === null || _a === void 0 ? void 0 : _a.meta) {
            return 44;
        }
        return 28;
    }, [(_c = spec.viewSpec.selectParams) === null || _c === void 0 ? void 0 : _c.meta]);
    const handleToggle = React.useCallback((open) => {
        if (open) {
            onFocus();
        }
        else {
            onBlur();
        }
    }, [onFocus, onBlur]);
    const _value = React.useMemo(() => transformArrOut(value), [value]);
    const handleChange = React.useCallback((value) => onChange(transformArrIn(value)), [onChange]);
    return (React.createElement(Select, Object.assign({ width: "max", className: b(), filterable: filterable, renderOption: renderOption, getOptionHeight: getOptionHeight }, inputProps, { value: _value, options: options, onUpdate: handleChange, onOpenChange: handleToggle, disabled: spec.viewSpec.disabled, placeholder: spec.viewSpec.placeholder, filterPlaceholder: (_d = spec.viewSpec.selectParams) === null || _d === void 0 ? void 0 : _d.filterPlaceholder, multiple: true, qa: name })));
};
